// DistributorContext.tsx
import React, { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

interface DistributorContextType {
  distributorId: number | null;
  setDistributorId: (id: number) => void;
}

const DistributorContext = createContext<DistributorContextType>({
  distributorId: null,
  setDistributorId: () => {}
});

export const DistributorProvider = ({ children }: { children: ReactNode }) => {
  const [distributorId, setDistributorIdState] = useState<number | null>(
    () => Number(localStorage.getItem("distributorId")) || null
  );

  const setDistributorId = (id: number) => {
    
    localStorage.setItem("distributorId", String(id));
    setDistributorIdState(id);
  };

  return (
    <DistributorContext.Provider value={{ distributorId, setDistributorId }}>
      {children}
    </DistributorContext.Provider>
  );
};

export const useDistributor = () => useContext(DistributorContext);
